import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';

var _excluded = ["ariaDescribedBy", "children", "classList", "description", "id", "inputProps", "isChecked", "isDisabled", "isInvalid", "isRequired", "name", "onChange", "value"];
var propTypes = {
  /** Specify what the checkbox is asking */
  description: PropTypes.node.isRequired,
  /** Assign a unique ID for the checkbox to be identifiable */
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  /** Used for alerting in some a11y patterns */
  ariaDescribedBy: PropTypes.string,
  children: PropTypes.node,
  /**
   * Use this prop to extend the styling according to your needs
   */
  classList: PropTypes.string,
  /** Arbitrary attributes to be applied to the `input` element */
  inputProps: PropTypes.object,
  /** Indicate whether the checkbox is checked */
  isChecked: PropTypes.bool,
  /** Indicate whether the checkbox is disabled */
  isDisabled: PropTypes.bool,
  /** Indicate whether the checkbox is invalid */
  isInvalid: PropTypes.bool,
  /** Indiciate whether the checkbox is required */
  isRequired: PropTypes.bool,
  /** Assign a general name for the checkbox to be recognizable */
  name: PropTypes.string,
  /** Specify the value sent to server */
  value: PropTypes.string
};
function Checkbox(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
    children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    description = _ref.description,
    id = _ref.id,
    inputProps = _ref.inputProps,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "checkbox ".concat(classList),
    "data-testid": "checkbox"
  }, props), /*#__PURE__*/React__default.createElement("input", _extends({
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": isInvalid,
    checked: isChecked,
    disabled: isDisabled,
    id: id,
    onChange: onChange,
    name: name,
    required: isRequired,
    type: "checkbox",
    value: value
  }, inputProps)), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "checkbox-icon",
    "data-testid": "checkbox-icon"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "checkbox-text"
  }, description)), children);
}
Checkbox.propTypes = propTypes;

export { Checkbox as default };
//# sourceMappingURL=Checkbox.js.map
